module.exports = {"data":{"site":{"siteMetadata":{"title":"Com des Lézards - Agence web depuis 2001"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 102
// module chunks = 60335399758886 79611799117203